import { mainBus } from "utils/bus";

export const onPlayingGif = ({ id }:{ id : string}) => {
  mainBus.emit("set_playing_gif", { id });
};

export const onFullScreen = ({ id, isForceFS }: { id: string; isForceFS?: boolean }) => {
  mainBus.emit("toggle_fullscreen", { id, isForceFS });
};

// Mark a camera as having been seen recently.
export const addStreamateCamera = (id: number) => {
  mainBus.emit("add_streamate_camera", id);
};

export const clearStreamateCameras = () => {
  mainBus.emit("clear_streamate_cameras");
};
